import React, { useContext, useEffect, useState, useRef } from 'react'
import ThreeSixtyIcon from '../../../partials/assets/360Icon.svg'
import Magic360Spinner from './Magic360Spinner'
import { Translations } from '../services/TranslationService'
import {
    MAGIC360_CODE,
    MAIN_IMAGE_CODE,
    ADDITIONAL_IMAGE_CODE,
    VIDEO_CODE
} from '../constants/PDPConstants'

const Thumbnail = ({
    mediaElement,
    modePlaylist,
    magic360media,
    showMore,
    showMoreLabel,
    isMainImage,
    isInnerGallery,
    index
}) => {
    const translations = useContext(Translations)
    const [videoThumbnail, setVideoThumbnail] = useState(
        'https://www.3m.com/3m_theme_assets/themes/3MTheme/assets/images/lazy-preloader-clear.gif'
    )
    const timeoutIdsRef = useRef([])
    /* istanbul ignore next */
    const getThumbnail = () => {
        if (window.bcThumbs !== null && window.bcThumbs !== undefined) {
            if (
                Object.prototype.hasOwnProperty.call(
                    window.bcThumbs,
                    `${mediaElement?.videoPlayerId}`
                )
            ) {
                setVideoThumbnail(window.bcThumbs[mediaElement?.videoPlayerId])
                return true
            }
            const innerTimeout = setTimeout(getThumbnail, 100)
            timeoutIdsRef.current.push(innerTimeout)
        } else {
            const outerTimeout = setTimeout(getThumbnail, 100)
            timeoutIdsRef.current.push(outerTimeout)
        }
    }
    useEffect(() => {
        getThumbnail()
        return () => {
            timeoutIdsRef.current.forEach(clearTimeout)
            timeoutIdsRef.current = []
        }
    }, [])

    return (
        <>
            {/* Images */}
            {(mediaElement?.usageCode === ADDITIONAL_IMAGE_CODE ||
                mediaElement?.usageCode === MAIN_IMAGE_CODE) && (
                <>
                    {showMore && <span>{showMoreLabel}</span>}
                    <img
                        src={`${mediaElement?.url}${isMainImage ? '?width=506' : ''}`}
                        alt={mediaElement?.altText}
                        loading="lazy"
                    ></img>
                </>
            )}
            {/* Videos */}
            {mediaElement?.usageCode === VIDEO_CODE && (
                <>
                    {showMore && <span>{showMoreLabel}</span>}
                    <div className="bc-thumbnail-container">
                        <img src={videoThumbnail} alt="video-thumbnail" />
                        <span
                            className="MMM--icn MMM--icn_arrowRight"
                            aria-hidden="true"
                        ></span>
                    </div>
                </>
            )}
            {/* 360 Spinners */}
            {mediaElement?.usageCode === MAGIC360_CODE && isInnerGallery && (
                <div className="sps2-pdp_gallery--magiczoom-inner">
                    <Magic360Spinner
                        altText={mediaElement?.altText}
                        magic360={magic360media?.find(
                            (element) => element.position === index
                        )}
                    />
                    <div className="sps2-pdp_gallery--hoverText sps2-pdp_gallery--hoverText-inner">
                        {`${translations.dragSpin} | ${translations.clickTapZoom}`}
                    </div>
                </div>
            )}
            {mediaElement?.usageCode === MAGIC360_CODE && !isInnerGallery && (
                <>
                    <div className="sps2-pdp_gallery--list-360icon">
                        <ThreeSixtyIcon
                            style={{ width: `${isMainImage ? '120px' : '40px'}` }}
                        />
                    </div>
                    {showMore && <span>{showMoreLabel}</span>}
                    <img
                        src={
                            magic360media?.find((element) => element.position === index)
                                ?.firstfileurl
                        }
                        alt={mediaElement?.altText}
                        loading="lazy"
                    ></img>
                </>
            )}
        </>
    )
}

Thumbnail.defaultProps = {
    showMore: false,
    isMainImage: false
}

export default Thumbnail
